function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styledComponent from 'styled-components';
import { useBreakpoints } from '../hooks/use-breakpoints';
import { GlobalVariants } from './style/global-variants';
/**
 * List of possible HTML tags.
 */

/**
 * Generate a styled-component `ThemedSyleFunction` based on a
 *   given component or string name of an HTML tag.
 *
 * @param source - Component or string name of an HTML tag (e.g.
 *   `div`, `mark`, `span`, etc.)
 */
var createStyledComponent = function createStyledComponent(source) {
  // Determine if this is an Html tag or a component.
  if (typeof source === 'string' && source in styledComponent) {
    // styled-components exports a series of functions that
    //   represent all of the standard Html tags as styled-
    //   components. Find the corresponding function and return
    //   it.
    return styledComponent[source];
  } // The typing on this method is highly specialized. Instead
  //   of trying to port that here we'll just let styled-components
  //   throw an error if there's a problem.


  return styledComponent(source);
};

var responsiveVariants = ['xsmall', 'small', 'smallAndDown', 'smallAndUp', 'medium', 'mediumAndDown', 'mediumAndUp', 'large'];
/**
 * Determine what variants to apply to this function based on
 *   the `useScreenSize` hook.
 */

var useGlobalVariants = function useGlobalVariants() {
  // Apply all responsive variants, which will be coerced into media queries
  return responsiveVariants;
};
/**
 * Determines the style definition that should be used
 *   for this particular instance of the component.
 *
 * If the styleDefinition is a function, the function
 *   will be executed with the given properties. Otherwise
 *   it will just return the style definition.
 *
 * @param props - Current properties for the component.
 * @param styleDefinition - Style definition for the component.
 */


var evaluateStyleDefinition = function evaluateStyleDefinition(props, styleDefinition) {
  if (!styleDefinition) {
    // If there is no definition, just return an empty object.
    return {};
  }

  if (typeof styleDefinition === 'function') {
    // If it's a function, evaluate it.
    return styleDefinition(props);
  } // ... otherwise, just return it.


  return styleDefinition;
};
/**
 * Required for SSR - moving responsive styling rules into style sheet via media queries.
 * Turns responsive variants into media queries based on theme breakpoints.
 * @param variant specific variant to convert to media query
 * @param style variant's style object
 * @returns media query with desired style for the breakpoint
 */


var InsertMediaQueries = function InsertMediaQueries(variant, style) {
  var breakpoints = useBreakpoints();

  switch (variant) {
    case 'xsmall':
      return _defineProperty({}, "@media (max-width: ".concat(breakpoints[0], "px)"), style);

    case 'small':
      return _defineProperty({}, "@media (min-width: calc(".concat(breakpoints[0], "px + 1px)) and (max-width: ").concat(breakpoints[1], "px)"), style);

    case 'medium':
      return _defineProperty({}, "@media (min-width: calc(".concat(breakpoints[1], "px + 1px)) and (max-width: ").concat(breakpoints[2], "px)"), style);

    case 'large':
      return _defineProperty({}, "@media (min-width: calc(".concat(breakpoints[2], "px + 1px))"), style);

    case 'smallAndDown':
      return _defineProperty({}, "@media (max-width: ".concat(breakpoints[1], "px)"), style);

    case 'mediumAndDown':
      return _defineProperty({}, "@media (max-width: ".concat(breakpoints[2], "px)"), style);

    case 'smallAndUp':
      return _defineProperty({}, "@media (min-width: calc(".concat(breakpoints[1], "px + 1px))"), style);

    case 'mediumAndUp':
      return _defineProperty({}, "@media (min-width: calc(".concat(breakpoints[2], "px + 1px))"), style);

    default:
      return style;
  }
};

var buildStyle = function buildStyle(style, variantsToApply, variantBank) {
  // Iterate over the variant set, finding each element
  //   and spreading it over the accumulated style.
  return variantsToApply.reduce(function (accStyle, variant) {
    // insert media queries for any responsive variants
    var chosenVariant = InsertMediaQueries(variant, variantBank[variant]); // Apply the style if it exists.

    if (chosenVariant) {
      accStyle = _objectSpread(_objectSpread({}, accStyle), chosenVariant); // Recurse in if needed

      if (chosenVariant.variants) {
        accStyle = buildStyle(accStyle, variantsToApply, chosenVariant.variants);
      }
    }

    return accStyle;
  }, style);
};
/**
 * Applies any style variants defined in `variants`
 *   based on the `props.variant`. Variants will be
 *   applied in the order in which they are declared.
 * (i.e. `['alt','strong']` will apply the `alt`
 *   variation, then the `strong` variation on top of
 *   the base style definition.)
 * A series of global variants are also available. These
 *   will be auto-applied based on application conditions.
 *   The most prominent example of this is are the
 *   responsive classes. See {@link GlobalVariants} for
 *   more details.
 *
 * @param props - Current property set of the component.
 * @param style - Base style set to apply variants to.
 * @param variants - Variant definitions.
 */


var useAppliedVariants = function useAppliedVariants(props, style, variants) {
  var _variantsToApply;

  // Gather the list of variants from the component
  var variantsToApply;

  if (!(props !== null && props !== void 0 && props.variant)) {
    variantsToApply = [];
  } else if (Array.isArray(props.variant)) {
    variantsToApply = _toConsumableArray(props.variant);
  } else {
    variantsToApply = [props.variant];
  } // Determine what variants from the global set
  //   want to be applied. Insert them first so
  //   custom variants are applied over the globals.


  (_variantsToApply = variantsToApply).unshift.apply(_variantsToApply, _toConsumableArray(useGlobalVariants())); // Just return style if no variants need to be applied


  if (variantsToApply.length === 0) {
    return style;
  } // Collect the final variant definition list.


  var variantBank = _objectSpread(_objectSpread({}, GlobalVariants.variants || {}), variants || {});

  return buildStyle(style, variantsToApply, variantBank);
};
/**
 * Wrap a component or Html element in the custom Own Up styling
 *   functionality.
 *
 * @param source - Component or Html element to wrap.
 * @param styleDefinition - Style definition common to all
 *   components of this type. See {@link OwnUpStyle} for more
 *   details.
 */


export var createOwnUpComponent = function createOwnUpComponent(source, styleDefinition) {
  var styledItem = createStyledComponent(source);
  return styledItem(function (props) {
    var _evaluateStyleDefinit = evaluateStyleDefinition(props, styleDefinition),
        variants = _evaluateStyleDefinit.variants,
        style = _objectWithoutProperties(_evaluateStyleDefinit, ["variants"]);

    return useAppliedVariants(props, style, variants);
  });
};